import Brands from './Brands';

export default Brands;
